module.exports = __webpack_public_path__ + "static/media/darcy_mcswain.c54099f4.png";